import styled from "styled-components";
import {
  EventContentScrollArea,
  EventPageWrapper,
} from "../../event/shared/page-layout";
import { EVENT_PAGE_MIN_WIDTH } from "../../event/shared/layout-constants";

export const PageWrapper = EventPageWrapper;

export const Title = styled.div`
  color: #121212;
  font-family: Pretendard;
  font-size: 35px;
  font-weight: 700;
`;

export const TabRow = styled.div`
  margin-top: 20px;
  border-bottom: 1px solid #e5e5e5;
`;

export const TabItem = styled.div`
  display: inline-block;
  padding: 0 0 12px;
  font-family: Pretendard;
  font-size: 18px;
  font-weight: 700;
  color: #7f25fb;
  border-bottom: 2px solid #7f25fb;
`;

export const ContentScrollArea = styled(EventContentScrollArea)`
  margin-top: 20px;
`;

export const ContentRow = styled.div`
  display: grid;
  grid-template-columns: minmax(280px, 1fr) minmax(280px, 1fr) minmax(
      504px,
      1.8fr
    );
  gap: 12px;
  width: 100%;
  min-width: ${EVENT_PAGE_MIN_WIDTH}px;
  min-height: 100%;
  box-sizing: border-box;
`;

export const ContentColumn = styled.div`
  min-width: 0;
  min-height: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;

  > * {
    flex: 1;
    min-height: 0;
    min-width: 0;
    width: 100%;
  }
`;

export const Panel = styled.div`
  min-height: 0;
  height: 100%;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  background: #fff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
`;

export const ListPanel = styled(Panel)``;

export const CenterPanel = styled(Panel)``;

export const DetailPanel = styled(Panel)``;

export const PanelHeader = styled.div`
  padding: 16px 18px;
  border-bottom: 1px solid #f0f0f0;
  font-family: Pretendard;
  font-size: 16px;
  font-weight: 700;
  color: #121212;
`;

export const PanelBody = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 16px 18px;
`;

export const ListPanelBody = styled(PanelBody)``;

export const MemberDetailTop = styled.div`
  flex-shrink: 0;
`;

export const MemberDetailLists = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  margin-top: 4px;
`;

export const CenterPanelBody = styled(PanelBody)`
  display: flex;
  flex-direction: column;
  padding: 14px 16px;
`;

export const StatusGroup = styled.div<{ $variant: "inProgress" | "completed" }>`
  margin-bottom: 14px;
  border-radius: 10px;
  border: 1px solid
    ${({ $variant }) => ($variant === "inProgress" ? "#e8d9ff" : "#e8e8e8")};
  background: ${({ $variant }) =>
    $variant === "inProgress" ? "#f8f5ff" : "#f5f6f8"};
  overflow: hidden;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const StatusGroupHeader = styled.div<{
  $variant: "inProgress" | "completed";
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 14px;
  border-bottom: 1px solid
    ${({ $variant }) => ($variant === "inProgress" ? "#e8d9ff" : "#e8e8e8")};
  background: ${({ $variant }) =>
    $variant === "inProgress" ? "#f3ebff" : "#eef0f3"};

  > .label {
    font-family: Pretendard;
    font-size: 13px;
    font-weight: 700;
    color: ${({ $variant }) =>
      $variant === "inProgress" ? "#7f25fb" : "#555"};
  }

  > .count {
    font-family: Pretendard;
    font-size: 11px;
    font-weight: 500;
    color: #969696;
  }
`;

export const StatusGroupBody = styled.div`
  padding: 12px 14px;
`;

export const SubSection = styled.div`
  &:not(:last-child) {
    margin-bottom: 12px;
    padding-bottom: 12px;
    border-bottom: 1px dashed #e0e0e0;
  }
`;

export const SubSectionTitle = styled.div`
  font-family: Pretendard;
  font-size: 12px;
  font-weight: 700;
  color: #666;
  margin-bottom: 8px;
`;

export const SearchRow = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 14px;
`;

export const SearchInput = styled.input`
  flex: 1;
  height: 38px;
  padding: 0 12px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  font-family: Pretendard;
  font-size: 13px;
  outline: none;

  &:focus {
    border-color: #7f25fb;
  }
`;

export const PurpleButton = styled.button`
  height: 38px;
  padding: 0 16px;
  border: none;
  border-radius: 8px;
  background: #7f25fb;
  color: #fff;
  font-family: Pretendard;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const GrayButton = styled.button`
  height: 38px;
  padding: 0 14px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  background: #fff;
  color: #666;
  font-family: Pretendard;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
`;

export const MemberRow = styled.button<{ $selected: boolean }>`
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) 26px 26px 30px minmax(0, 1fr);
  gap: 4px;
  align-items: center;
  width: 100%;
  min-width: 0;
  padding: 10px 6px;
  border: none;
  border-radius: 10px;
  background: ${({ $selected }) => ($selected ? "#f3ebff" : "#fff")};
  cursor: pointer;
  text-align: center;
  margin-bottom: 4px;
  box-sizing: border-box;

  &:hover {
    background: #f8f5ff;
  }

  > .user {
    display: flex;
    align-items: center;
    gap: 8px;
    text-align: left;
    min-width: 0;
  }

  .nickname {
    font-family: Pretendard;
    font-size: 13px;
    font-weight: 700;
    color: #121212;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  > .stat {
    font-family: Pretendard;
    font-size: 12px;
    color: #666;
    font-weight: 500;
  }

  > .stat.unclaimed {
    color: #7f25fb;
    font-weight: 600;
  }

  > .stat.recent {
    font-size: 10px;
    color: #969696;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const Avatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #e8e8e8;
  flex-shrink: 0;
`;

export const MemberTableHeader = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) 26px 26px 30px minmax(0, 1fr);
  gap: 4px;
  align-items: center;
  padding: 8px 6px 10px;
  min-width: 0;
  font-family: Pretendard;
  font-size: 11px;
  font-weight: 600;
  color: #969696;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 4px;
  text-align: center;
  box-sizing: border-box;

  > .user {
    text-align: left;
    padding-left: 4px;
  }

  > .unclaimed {
    color: #7f25fb;
  }
`;

export const MemberTableBody = styled.div`
  min-height: 0;
  min-width: 0;
`;

export const MemberCard = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px;
  border-radius: 10px;
  background: #f8f9fb;
  margin-bottom: 16px;
`;

export const MemberInfo = styled.div`
  flex: 1;
  min-width: 0;

  > .nickname {
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 700;
    color: #121212;
  }
`;

export const SummaryBoxes = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
`;

export const SummaryBox = styled.div`
  flex: 1;
  padding: 12px;
  border-radius: 8px;
  background: #f5f6f8;
  text-align: center;

  > .value {
    font-family: Pretendard;
    font-size: 20px;
    font-weight: 700;
    color: #121212;
  }

  > .label {
    font-family: Pretendard;
    font-size: 12px;
    color: #666;
    margin-top: 4px;
  }
`;

export const Section = styled.div`
  margin-bottom: 18px;
`;

export const SectionTitle = styled.div`
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 700;
  color: #121212;
  margin-bottom: 10px;
`;

export const FilterBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
`;

export const FilterNameRow = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;

  > input {
    flex: 1;
    min-width: 0;
    height: 32px;
    padding: 0 8px;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    font-family: Pretendard;
    font-size: 12px;
    outline: none;
  }
`;

export const FilterDateRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: nowrap;
`;

export const FilterDateField = styled.div`
  flex: 1;
  min-width: 0;

  > input {
    width: 100%;
    height: 32px;
    padding: 0 4px;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    font-family: Pretendard;
    font-size: 11px;
    outline: none;
    box-sizing: border-box;
  }
`;

export const FilterDateSeparator = styled.span`
  font-family: Pretendard;
  font-size: 12px;
  color: #969696;
  flex-shrink: 0;
  padding: 0 2px;
`;

export const ListItem = styled.button<{ $selected: boolean }>`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid ${({ $selected }) => ($selected ? "#7f25fb" : "#e8e8e8")};
  border-radius: 8px;
  background: ${({ $selected }) => ($selected ? "#f3ebff" : "#fff")};
  cursor: pointer;
  margin-bottom: 6px;
  text-align: left;

  > .name {
    font-family: Pretendard;
    font-size: 13px;
    font-weight: 600;
    color: #121212;
    flex: 1;
    min-width: 0;
  }

  > .progress {
    font-family: Pretendard;
    font-size: 12px;
    color: #7f25fb;
    font-weight: 600;
    white-space: nowrap;
  }
`;

export const DetailTitle = styled.div`
  font-family: Pretendard;
  font-size: 18px;
  font-weight: 700;
  color: #121212;
  margin-bottom: 12px;
`;

export const BadgeRow = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 14px;
`;

export const Badge = styled.span<{ $variant?: "default" | "purple" | "dark" }>`
  display: inline-flex;
  align-items: center;
  height: 26px;
  padding: 0 10px;
  border-radius: 6px;
  font-family: Pretendard;
  font-size: 12px;
  font-weight: 600;
  background: ${({ $variant }) =>
    $variant === "purple"
      ? "#f3ebff"
      : $variant === "dark"
        ? "#373636"
        : "#f0f0f0"};
  color: ${({ $variant }) =>
    $variant === "purple" ? "#7f25fb" : $variant === "dark" ? "#fff" : "#666"};
`;

export const ActionButton = styled.button<{ $variant?: "primary" | "danger" }>`
  height: 40px;
  padding: 0 20px;
  border: none;
  border-radius: 8px;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  background: ${({ $variant }) =>
    $variant === "danger" ? "#ff4d4f" : "#7f25fb"};
  color: #fff;
  margin-bottom: 16px;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ProgressSection = styled.div`
  margin-bottom: 16px;
`;

export const ProgressText = styled.div`
  font-family: Pretendard;
  font-size: 28px;
  font-weight: 700;
  color: #7f25fb;
  margin-bottom: 8px;
`;

export const ProgressBar = styled.div`
  height: 8px;
  border-radius: 4px;
  background: #e8e8e8;
  margin-bottom: 12px;

  > .fill {
    height: 100%;
    border-radius: 4px;
    background: #7f25fb;
    transition: width 0.2s;
  }
`;

export const ProgressControls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`;

export const ProgressStepper = styled.div`
  display: flex;
  align-items: center;
`;

export const StepperButton = styled.button`
  width: 36px;
  height: 36px;
  border: 1px solid #d9d9d9;
  background: #fff;
  font-family: Pretendard;
  font-size: 18px;
  line-height: 1;
  color: #121212;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  &:first-of-type {
    border-radius: 8px 0 0 8px;
    border-right: none;
  }

  &:last-of-type {
    border-radius: 0 8px 8px 0;
    border-left: none;
  }

  &:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }

  &:not(:disabled):hover {
    background: #f5f5f5;
  }
`;

export const StepperInput = styled.input`
  width: 56px;
  height: 36px;
  padding: 0 4px;
  border: 1px solid #d9d9d9;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  outline: none;
  box-sizing: border-box;

  &:focus {
    border-color: #7f25fb;
  }
`;

export const SmallInput = styled.input`
  width: 70px;
  height: 36px;
  padding: 0 8px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  font-family: Pretendard;
  font-size: 13px;
  text-align: center;
  outline: none;
`;

export const SubText = styled.div`
  font-family: Pretendard;
  font-size: 12px;
  color: #969696;
`;

export const RewardTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: Pretendard;
  font-size: 12px;
  table-layout: fixed;

  th {
    padding: 8px 4px;
    border-bottom: 1px solid #e8e8e8;
    color: #666;
    font-weight: 600;
    text-align: center;
    word-break: keep-all;
  }

  td {
    padding: 10px 4px;
    border-bottom: 1px solid #f0f0f0;
    text-align: center;
    color: #121212;
    word-break: keep-all;
  }
`;

export const StatusBadge = styled.span<{ $status: string }>`
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  background: ${({ $status }) => {
    if ($status === "수령 가능") return "#7f25fb";
    if ($status === "수령완료" || $status === "지급") return "#373636";
    return "#969696";
  }};
  color: #fff;
`;

export const BingoGridWrap = styled.div`
  flex: 1;
  min-width: 0;
`;

export const BingoGrid = styled.div<{ $size: number }>`
  display: grid;
  grid-template-columns: repeat(${({ $size }) => $size}, minmax(0, 1fr));
  gap: 6px;
  margin-bottom: 12px;
  width: 100%;
`;

export const BingoCell = styled.button<{
  $selected: boolean;
  $complete: boolean;
}>`
  width: 100%;
  aspect-ratio: 1 / 1;
  min-width: 0;
  min-height: 0;
  height: auto;
  padding: 4px;
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px solid ${({ $selected }) => ($selected ? "#7f25fb" : "#d9d9d9")};
  background: ${({ $selected, $complete }) =>
    $selected ? "#7f25fb" : $complete ? "#373636" : "#fff"};
  color: ${({ $selected, $complete }) =>
    $selected || $complete ? "#fff" : "#121212"};
  cursor: pointer;
  font-family: Pretendard;
  font-size: 10px;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  overflow: hidden;

  > .name {
    width: 100%;
    max-width: 100%;
    white-space: normal;
    word-break: keep-all;
    overflow-wrap: break-word;
    text-align: center;
    line-height: 1.25;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  > .progress {
    font-size: 9px;
    font-weight: 500;
    opacity: 0.9;
    white-space: nowrap;
  }
`;

export const BingoLayout = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  align-items: flex-start;
`;

export const CellSidePanel = styled.div`
  flex: 1 1 220px;
  min-width: 220px;
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  padding: 14px;
  background: #fafafa;
  box-sizing: border-box;

  ${SectionTitle} {
    word-break: keep-all;
    overflow-wrap: break-word;
    line-height: 1.4;
  }

  ${SubText} {
    word-break: keep-all;
    overflow-wrap: break-word;
    line-height: 1.45;
    white-space: normal;
  }
`;

export const EmptyMessage = styled.div`
  padding: 24px 0;
  text-align: center;
  color: #969696;
  font-family: Pretendard;
  font-size: 13px;
`;

export const PaginationBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 8px;

  > div {
    position: static;
    left: auto;
    transform: none;
    margin-top: 0;
  }
`;

export const ConfirmPopup = styled.div`
  width: min(480px, calc(100vw - 48px));
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
`;

export const ConfirmPopupHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;

  > .title {
    color: #121212;
    font-family: Pretendard;
    font-size: 18px;
    font-weight: 700;
  }

  > img {
    width: 17px;
    height: 17px;
    cursor: pointer;
  }
`;

export const ConfirmPopupDivider = styled.div`
  height: 1px;
  background: #e8e8e8;
`;

export const ConfirmPopupBody = styled.div`
  padding: 24px;
  color: #666;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.6;
  word-break: keep-all;
  display: flex;
  flex-direction: column;
  gap: 16px;

  > p {
    margin: 0;
  }
`;

export const ConfirmPopupMemoField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  > label {
    color: #121212;
    font-family: Pretendard;
    font-size: 13px;
    font-weight: 600;
  }

  > textarea {
    width: 100%;
    min-height: 84px;
    padding: 10px 12px;
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    font-family: Pretendard;
    font-size: 13px;
    font-weight: 500;
    color: #121212;
    line-height: 1.5;
    resize: vertical;
    outline: none;
    box-sizing: border-box;

    &::placeholder {
      color: #b7b7b7;
    }

    &:focus {
      border-color: #7f25fb;
    }
  }
`;

export const ConfirmPopupFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 16px 24px 20px;

  > button {
    min-width: 72px;
    height: 40px;
    padding: 0 16px;
    border: none;
    border-radius: 8px;
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
  }

  > .cancel {
    background: #e8e8e8;
    color: #121212;
  }

  > .confirm {
    background: #d91818;
    color: #fff;
  }
`;
